import React from 'react';
import { motion } from 'framer-motion';
import { Quote as QuoteIcon } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function AboutMeSection() {
  const {
    t
  } = useLanguage();
  return <section id="sobre-mi" className="py-16 sm:py-20 md:py-32 px-4 sm:px-6 bg-cream relative overflow-hidden" data-id="element-12">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-20" data-id="element-14">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-forest-dark mb-6 uppercase leading-tight" data-id="element-15">
            {t('nav.about')}
          </h2>
          <div className="w-16 h-[1px] bg-terracotta mx-auto" data-id="element-16"></div>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-17">
          {/* LEFT: Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-5 lg:sticky lg:top-32" data-id="element-18">
            <div className="aspect-[4/5] rounded-[2.5rem] overflow-hidden relative shadow-2xl border border-sage-light/30" data-id="element-19">
              <div className="absolute inset-0 bg-gradient-to-t from-forest-dark/80 via-transparent to-transparent z-10" data-id="element-20"></div>
              <img src="https://cdn.magicpatterns.com/uploads/wSsFzdU5JR66c2yvo8zajF/foto_8.jpg" alt="Georgina Fahle Ruiz" className="w-full h-full object-cover" style={{
              objectPosition: '50% 20%'
            }} data-id="element-21" />
              <div className="absolute bottom-0 left-0 right-0 p-8 z-20" data-id="element-22">
                <h3 className="text-3xl font-serif text-cream mb-2" data-id="element-23">
                  {t('about.name')}
                </h3>
                <p className="text-gold-light font-light leading-snug" data-id="element-24">
                  {t('about.title')}
                </p>
              </div>
            </div>
          </motion.div>

          {/* RIGHT: Bio */}
          <div className="lg:col-span-7 space-y-8 text-lg text-forest/80 leading-relaxed font-light" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-25">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-26">
              {t('about.p1')}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-27">
              {t('about.p2')}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-28">
              {t('about.p3')}
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-29">
              {t('about.p4')}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-sage-lighter/30 p-8 rounded-3xl border border-sage-light/20 mt-12 text-center" data-id="element-30">
              <p className="text-2xl font-serif text-gold-dark italic mb-8" data-id="element-31">
                {t('about.q')}
              </p>
              <a href="#contacto" className="inline-flex items-center justify-center px-10 py-4 bg-forest text-cream font-bold tracking-widest uppercase rounded-full hover:bg-forest-dark transition-colors shadow-lg" data-id="element-32">
                {t('about.cta')}
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}